import Vue from 'vue';
import Btn from '@/components/~Global/Buttons/Btn';
import BtnLink from '@/components/~Global/Buttons/BtnLink';
import BtnNavigation from '@/components/~Global/Buttons/BtnNavigation';


import ModalDialog from '@/components/~Global/Dialogs/ModalDialog';
import ModalConfirm from '@/components/~Global/Dialogs/ModalConfirm';
import ModalConfirmDialog from '@/components/~Global/Dialogs/ModalConfirmDialog';
import ModalFeedbackDialog from '@/components/~Global/Dialogs/ModalFeedbackDialog';
import ModalThanksDialog from '@/components/~Global/Dialogs/ModalThanksDialog';

import ModalParticipantInfoDialog from '@/components/~Global/Dialogs/ModalParticipantInfoDialog';

import InputTextValidated from '@/components/~Global/InputFields/InputTextValidated';
import InputTimeField from '@/components/~Global/InputFields/InputTimeField';
import InputSelectField from '@/components/~Global/InputFields/InputSelectField';

import InputText from '@/components/UI/InputText.vue';



// Register global Button components
Vue.component('Btn', Btn);
Vue.component('BtnLink', BtnLink);
Vue.component('BtnNavigation', BtnNavigation);


// Register global Modal components
Vue.component('ModalDialog', ModalDialog);
Vue.component('ModalConfirm', ModalConfirm);
Vue.component('ModalConfirmDialog', ModalConfirmDialog);
Vue.component('ModalFeedbackDialog', ModalFeedbackDialog);
Vue.component('ModalThanksDialog', ModalThanksDialog);
Vue.component('ModalParticipantInfoDialog', ModalParticipantInfoDialog);

// Register global Input  components
Vue.component('InputTextValidated', InputTextValidated);
Vue.component('InputText', InputText);

Vue.component('InputTimeField', InputTimeField);
Vue.component('InputSelectField', InputSelectField);



